module.exports = __webpack_public_path__ + "site/img/academicResearch.35aa894.png";


//////////////////
// WEBPACK FOOTER
// ./site/academicResearch.png
// module id = 94
// module chunks = 1